import { IAdUnit } from "@/components/ads/config/unit";
import { isCookieDeclined } from "@/common/utils/cookie";

const RETRY_LIMIT = 5;
const RETRY_TIMEOUT = 1000;

export const addAdvertisment = async (props: IAdUnit, iteration: number | undefined = 0) => {
  if (iteration > RETRY_LIMIT) {
    return;
  }

  if (await isCookieDeclined(["advertisement"])) {
    return;
  }

  if (!window?.goCtrl?.add) {
    console.debug("[ads] goCtrl instance not found");
    setTimeout(() => {
      addAdvertisment(props, iteration + 1);
    }, RETRY_TIMEOUT);
    return;
  }

  console.debug("[ads] goCtrl is ready.");

  window.goCtrl.add(props);
};
